// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"d81a0d1883b9e703","6831":"340ff1dcf4f07d10","8503":"86a9812687f9ecdd","9683":"fbf9d5ca4afdec64"}[chunkId] + ".js";
};